import { render } from "./HelloWorld.vue?vue&type=template&id=4553ee95&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=4553ee95&scoped=true&lang=css"

import exportComponent from "T:\\work\\projects\\mini\\numfuse-prefill-editor\\editor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4553ee95"]])

export default __exports__